/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import Reveal from "./Reveal";
import { fetchSiteContent } from "@/lib/api";

const POINTS = [
  "Your company name on every certificate",
  "The specific project your order contributed to",
  "Number of trees planted on your behalf",
  "Independently verified by Grow-Trees",
  "Placed inside every hamper at delivery",
];

const resolveAsset = (u) =>
  !u ? "" : u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`;

export default function Certificate() {
  const [certImg, setCertImg] = useState("");
  useEffect(() => {
    let alive = true;
    fetchSiteContent()
      .then((data) => {
        if (!alive) return;
        setCertImg(resolveAsset(data?.green_gift_certificate_image || ""));
      })
      .catch(() => { /* silent — fallback rendering handled below */ });
    return () => { alive = false; };
  }, []);

  return (
    <section className="section certificate">
      <div className="section-inner">
        <div className="cert-grid">
          <div>
            <Reveal className="eyebrow">The Impact Certificate</Reveal>
            <Reveal as="h2" delay={1} className="section-headline">
              Let your team know a tree was planted <em>in their name.</em>
            </Reveal>
            <Reveal as="p" delay={2} className="section-sub" style={{ marginTop: 20 }}>
              Every recipient of an Utsah hamper receives an impact certificate — placed inside the box at delivery — with your company's name on it.
            </Reveal>
            <div className="cert-points">
              {POINTS.map((p, i) => (
                <Reveal key={p} delay={i > 3 ? 3 : i} className="cert-point">
                  <div className="cert-point-icon">✓</div>
                  <div className="cert-point-text">{p}</div>
                </Reveal>
              ))}
            </div>
          </div>
          <Reveal delay={1} className="cert-image-wrap" data-testid="cert-image-wrap">
            {certImg ? (
              <img
                src={certImg}
                alt="Sample Grow-Trees Impact Certificate"
                className="cert-image"
                data-testid="cert-image"
                loading="lazy"
              />
            ) : (
              <div className="cert-image-fallback" aria-hidden />
            )}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
